import { render, staticRenderFns } from "./PathButton.vue?vue&type=template&id=4bd4e9b6&scoped=true&"
import script from "./PathButton.vue?vue&type=script&lang=js&"
export * from "./PathButton.vue?vue&type=script&lang=js&"
import style0 from "./PathButton.vue?vue&type=style&index=0&id=4bd4e9b6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bd4e9b6",
  null
  
)

export default component.exports